module.exports = __webpack_public_path__ + "img/MH.3a657180.png";